import { Routes } from '@angular/router';
import { AuthGuard } from 'libs/auth/src/public-api';
import { Role } from 'libs/core/src/public-api';

export const routes: Routes = [
  // Auth routes
  {
    path: 'auth',
    loadComponent: () =>
      import('libs/layouts/src/public-api').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('libs/auth/src/public-api').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('libs/auth/src/public-api').then((m) => m.RegisterComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('libs/auth/src/public-api').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: 'password-reset',
        loadComponent: () =>
          import('libs/auth/src/public-api').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },

  // Private routes
  {
    path: '',
    loadComponent: () =>
      import('libs/layouts/src/public-api').then(
        (m) => m.PrivateLayoutComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'form-builder',
        pathMatch: 'full',
      },
      {
        path: 'form-builder',
        loadChildren: () =>
          import('./feature/form-builder/form-builder.routes').then(
            (m) => m.default,
          ),
      },
      {
        path: 'operators',
        loadChildren: () =>
          import('./feature/operators/operators.routes').then((m) => m.default),
      },
      {
        path: 'companies',
        loadChildren: () =>
          import('./feature/companies/companies.routes').then((m) => m.default),
      },
      {
        path: 'admins',
        canMatch: [AuthGuard],
        loadChildren: () =>
          import('./feature/admins/admins.routes').then((m) => m.default),
        data: {
          roles: [Role.SUPER_ADMIN],
        },
      },
      {
        path: 'report-incident',
        loadChildren: () =>
          import('./feature/report-incident/report-incident.routes').then(
            (m) => m.default,
          ),
      },
      {
        path: 'report-avoided-incident',
        loadChildren: () =>
          import('./feature/report-incident/report-incident.routes').then(
            (m) => m.avoidedReportIncidentRoutes,
          ),
      },
      {
        path: 'incident-submissions',
        loadChildren: () =>
          import('./feature/submitted-forms/submitted-forms.routes').then(
            (m) => m.default,
          ),
      },
      {
        path: 'avoided-incidents',
        loadChildren: () =>
          import('./feature/submitted-forms/avoided-incidents.routes').then(
            (m) => m.default,
          ),
      },
      {
        path: 'update-profile',
        loadChildren: () =>
          import('libs/feature/update-profile/src/public-api').then(
            (m) => m.updateProfileRoutes,
          ),
      },
      {
        path: 'activity-logs',
        loadChildren: () =>
          import('./feature/activity-logs/activity-logs.routes').then(
            (m) => m.default,
          ),
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },

  {
    path: '',
    redirectTo: 'form-builder',
    pathMatch: 'full',
  },

  // Fallback for unknown paths
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
